const saveDetailsFormToLocalStorage = (values) => {
  const { tableName, email, name, phone, countryCode, pickupTime, pickupDay } = values;
  window.localStorage.setItem('detailsForm', JSON.stringify({ email, name, phone, countryCode }));
  window.sessionStorage.setItem(
    'detailsForm',
    JSON.stringify({ tableName, pickupTime, pickupDay }),
  );
};

export default saveDetailsFormToLocalStorage;
